
import { Component, Prop, Vue } from 'vue-property-decorator';
import MfaWarning from '@/components/authentication/MfaWarning.vue';

@Component({
  components: {
    MfaWarning,
  },
})
export default class BaseHeader extends Vue {
  @Prop({ type: String, default: 'large' })
  mod!: string;

  @Prop({ type: String, default: 'direct' })
  titleMod!: string;

  @Prop({ type: String, default: 'small' })
  introMod!: string;

  @Prop({ type: Boolean, default: false })
  checkMfa!: boolean;

  get hasMfa(): boolean {
    return this.$store.getters['auth/hasMfa'];
  }
}
